export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";